import { Tariff } from '@/types/tariff';

export const getTariffsInitialState = (tariffsInfoData: Tariff.TariffsInfoResponse) =>
	tariffsInfoData.tariffsInfo.sort((a, b) => a.order - b.order).slice(0, 5);
